import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const avatarTheme: Pick<Components<Theme>, 'MuiAvatar'> = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        '.svg-inline--fa': {
          fontSize: 'inherit', // Avatar controls the size of the icon
        },
      },
    },
  },
};
